<script>
/**
 * 内联 SVG 图标（自 vancheen-b2b 的 SvgIcon.vue 移植为 Vue 2 版本）
 */
import icons from '../nh-icons'

export default {
  name: 'NhSvgIcon',
  props: {
    name: { type: String, required: true }
  },
  computed: {
    html() {
      return icons[this.name] || ''
    }
  }
}
</script>

<template>
  <span class="svg-ic" v-html="html" />
</template>
